<template>
  <RadioGroup>
    <div class="flex items-stretch gap-2">
      <RadioGroupOption
        v-for="size in bundleSizes"
        :key="size"
        :value="size"
        as="template"
      >
        <button
          data-gtm-action="select size"
          :data-gtm-label="size"
          :class="selectedSize === size && 'selected'"
          class="box-button basis-1/2"
          @click="handleSelect(size)"
        >
          <span
            v-if="size === MAX_SIZE"
            class="button-tag button-tag-top"
          >
            {{ $bt('size_best_value', bundleType) }}
          </span>
          <h2>
            {{ size }} {{ $bt('meals', bundleType) }}
            <slot v-if="showPricing" name="pricing" v-bind="{ size }" />
          </h2>
        </button>
      </RadioGroupOption>
    </div>
  </RadioGroup>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useBundleStore } from '@/stores'
import { updateVariantSelectParams } from '@/services/bundle-url-params'
import { RadioGroup, RadioGroupOption } from '@headlessui/vue'
import type { BundleSize } from '@/types/bundle'
import { useThemeStore } from '@/stores'

const SizeSelectModal = () => import('./size-select-modal.vue')

defineProps<{
  showPricing?: boolean
}>()

const store = useBundleStore()
const { bundleSizes, bundleType, MAX_SIZE } = store
const { totalQuantity, selectedSize } = storeToRefs(store)

const { modal } = useThemeStore()
const reduceSize = ref<BundleSize>()
const handleSelect = (size: BundleSize) => {
  if (size < totalQuantity.value) {
    reduceSize.value = size
    modal.open(SizeSelectModal, { reduceSize: size, totalQuantity: totalQuantity.value })
    return
  }
  reduceSize.value = undefined
  selectedSize.value = size
  updateVariantSelectParams({ size })
}
</script>
